import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import fr from 'vuetify/src/locale/fr'
import en from 'vuetify/src/locale/en'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { fr, en },
    current: 'fr'
  },

  text: {
    color: '#343232'
  },

  theme: {
    themes: {
      light: {
        primary: '#7E003F',
        secondary: '#A20646',
        accent: '#00838E',
        info: '#00838E',
        success: '#00838E',
        error: '#DE3138',
        warning: '#DE802D',
        anchor: '#7E003F'
      }
      //dark: {
      //   primary: '#00838ES',
      //  secondary: '#7b1e1e',
      //  accent: '#E0E0E0'
      //}
    }
  }
})
